import { useRef, useState } from 'react';
import { Box, Button, Icons, styled, Text } from '@/theme/index';
import { ReportSectionData } from '@/utils/helperTypes';
import { RestoreDataModal } from './feedbackModals';
import { useRestoreData } from './feedbackUtils';
import { NormalizedBonusData } from '../sections/FreeBonusData/LicensesAndPermits/types';
import { serializedTypes } from '../types';

const StyledButton = styled(Button)(
  ({ theme }) => `
  padding: 0;
  margin: ${theme.spacing(1.25)} 0 ${theme.spacing(0.75)} 0;

  &:hover {
    background-color: transparent;
  }
`
);

const StyledText = styled(Text)`
  line-height: 1;
  letter-spacing: 0.5px;
  font-weight: bold;

  &:hover {
    text-decoration: underline;
  }
`;

export const RestoreAllDataButton = ({
  items,
  permalink,
}: {
  items:
    | ReportSectionData[]
    | serializedTypes.Connection[]
    | NormalizedBonusData[];
  permalink: string;
}) => {
  const hasHiddenItems = items.some((item) => item.hidden);
  const jsonPaths = items.map((item) => item.jsonPath);
  const containerRef = useRef(null);
  const [restoreModalOpen, setRestoreModalOpen] = useState(false);
  const handleRestoreModalOpen = (change: boolean) =>
    setTimeout(() => setRestoreModalOpen(change), 5);
  const restoreMutation = useRestoreData(permalink, () =>
    handleRestoreModalOpen(false)
  );
  const handleRestoreAction = () => {
    restoreMutation.mutate({ jsonPaths, permalink });
  };

  if (!hasHiddenItems) return null;
  return (
    <>
      <Box
        ref={containerRef}
        display="flex"
        flexDirection="row-reverse"
        position="relative"
      >
        <StyledButton
          color="primary"
          onClick={() => handleRestoreModalOpen(true)}
        >
          <Icons.UndoRounded sx={{ height: 20, width: 20 }} />
          <StyledText variant="body1">Restore all hidden data</StyledText>
        </StyledButton>
      </Box>
      <RestoreDataModal
        open={restoreModalOpen}
        handleOpen={handleRestoreModalOpen}
        handleAction={handleRestoreAction}
        containerRef={containerRef}
      />
    </>
  );
};

export const RemoveDataButton = ({
  item,
  handleClick,
}: {
  item: ReportSectionData | serializedTypes.Connection | NormalizedBonusData;
  handleClick: () => NodeJS.Timeout;
}) => {
  if (item.downvoted) {
    return (
      <StyledButton onClick={handleClick}>
        <Icons.CloseRounded sx={{ height: 20, width: 20 }} />
        <StyledText variant="body1">Hide</StyledText>
      </StyledButton>
    );
  }
  return null;
};
